module.exports = __webpack_public_path__ + "img/duns-registered.251fba26.jpg";